import AddVehicleInfoGroupNoparentModal from './add-vehicle-info-group-noparent-modal.vue'
export default AddVehicleInfoGroupNoparentModal
